function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAgents = function SvgAgents(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 2",
    viewBox: "0 0 173.68 195.83"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M124.06 97.99c.15-.32.31-.63.45-.96L173.68 0h-19.29l-39.91 79.69L75.57 0H56.28l21.44 43.44-18.16 36.25L20.65 0H1.36l47.89 97.04c.12.27.25.53.38.8-.15.32-.31.63-.45.96L0 195.83h19.29l39.91-79.69 38.92 79.69h19.29l-21.44-43.44 18.16-36.25 38.92 79.69h19.29l-47.89-97.04c-.12-.27-.25-.53-.38-.8ZM86.6 133.32c.07.17.14.35.21.53l-17.3-35.06c-.12-.27-.25-.53-.38-.8.15-.32.31-.63.45-.96l17.5-34.53c-.07-.18-.14-.35-.21-.53l17.3 35.06c.12.27.25.53.38.8-.15.32-.31.63-.45.96z",
    "data-name": "Layer 1",
    style: {
      fill: "#121212"
    }
  }));
};
export default SvgAgents;